import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@/store";

export const selectPlaidState = (state: RootState) => state.plaid;

export const selectPlaidAccounts = createSelector(
  [selectPlaidState],
  (plaid) => plaid.accounts,
);

export const selectPlaidChartData = createSelector(
  [selectPlaidState],
  (plaid) => plaid.chartData,
);

export const selectPlaidSummary = createSelector(
  [selectPlaidState],
  (plaid) => plaid.summary,
);

export const selectPlaidHoldings = createSelector(
  [selectPlaidState],
  (plaid) => plaid.holdings,
);

export const selectPlaidTransactions = createSelector(
  [selectPlaidState],
  (plaid) => plaid.transactions,
);
// export const selectPlaidAggregatedData = createSelector(
//   [selectPlaidState],
//   (plaid) => plaid.aggregatedData,
// );

// export const selectPlaidIsAggregatedDataLoading = createSelector(
//   [selectPlaidState],
//   (plaid) => plaid.isAggregatedDataLoading,
// );

export const selectPlaidLastUpdated = createSelector(
  [selectPlaidState],
  (plaid) => plaid.lastUpdated,
);

export const selectPlaidConnectionStatus = createSelector(
  [selectPlaidState],
  (plaid) => plaid.connectionStatus,
);

export const selectPlaidConnectionError = createSelector(
  [selectPlaidState],
  (plaid) => plaid.connectionError,
);

export const selectPlaidLoading = createSelector(
  [selectPlaidState],
  (plaid) => plaid.loading,
);

export const selectPlaidError = createSelector(
  [selectPlaidState],
  (plaid) => plaid.error,
);

export const selectPlaidHasNoLinkedAccounts = createSelector(
  [selectPlaidState],
  (plaid) => plaid.plaidHasNoLinkedAccounts,
);

export const selectPlaidSnapshotUnavailable = createSelector(
  [selectPlaidState],
  (plaid) => plaid.plaidSnapshotUnavailable,
);

const selectPlaidSnapshotId = createSelector(
  [selectPlaidState],
  (plaid) => plaid.snapshotId,
);

const selectPlaidSnapshotAsOf = createSelector(
  [selectPlaidState],
  (plaid) => plaid.snapshotAsOf,
);

export const selectPlaidSnapshotMeta = createSelector(
  [selectPlaidSnapshotId, selectPlaidSnapshotAsOf],
  (snapshotId, snapshotAsOf) => ({
    snapshotId,
    snapshotAsOf,
  }),
);
